import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { 
    Container, 
    Row, Col, Card, 
    CardBody, CardTitle, Table,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, Modal, Alert, Input, Button, Badge} from "reactstrap";
import { Link } from 'react-router-dom';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { formatDate, HRConfig, TOAST_OPTIONS } from './../../helpers/backend_helper';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";
import { useHistory } from 'react-router-dom';

const RecruitmentRequisitions = () => {

      const history = useHistory()
        const [dCases, setDCases] = useState([])
        const [modal, setmodal] = useState(false);
        const [modal_details, setmodal_details] = useState(false);
        const [isLoading, setIsLoading] = useState(false)
        const [empNo, setEmpNo] = useState('')
        const [empName, setEmpName] = useState('')
        const [empTitle, setEmpTitle] = useState('')
        const [postingDate, setPostingDate] = useState(new Date())
        const [skills, setSkills] = useState([])
        const [details, setDetails] = useState(null)

        toastr.options = TOAST_OPTIONS;

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
   
       

        const getData = () =>{
            setIsLoading(true)
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setEmpNo(obj.uid)
                setEmpName(obj.username)
                axios.get(`${url.EMPLOYEES}?$filter=No eq '${obj.uid}'`, HRConfig).then((r)=>{ setEmpTitle(r.data.value[0].JobTitle)}).catch((e)=>{ console.log(e)})
            
                axios.get(`${url.RECRUITMENTS1}?$filter=RequisitionerNo eq '${obj.uid}' &$expand=recruitmentLines`, HRConfig).then((r)=>{ 
                    setIsLoading(false)
                    setDCases(r.data.value)
                }).catch((e)=>{ console.log(e); setIsLoading(false); })
            }
    
            axios.get(url.SKILLS, HRConfig).then((r)=>{ 
                setSkills(r.data.value)
            }).catch((e)=>{ console.log(e) })
        }
        useEffect(()=>{
           getData()
        },[])
        const { SearchBar } = Search;
        const columns = [
            {
              dataField: 'No',
              text: 'No',
              sort: true,
              formatter: noFormatter
            },
            {
              dataField: 'RecruitmentMethods', 
              text: 'Method',
              sort: true
            }, 
            {
                dataField: 'EmployeeNo',
                isDummyField: true,
                text: 'Plan By',
                sort: true,
                formatter: raisedByFormatter
              }, 
              {
                dataField: 'ShortcutDimension2Code',
                text: 'Location',
                sort: true
              }, 
            {
              dataField: 'RequisitionDate',
              text: 'Requisition Date',
              sort: true
            }, 
            {
                dataField: 'recruitmentLines',
                isDummyField: true,
                text: 'Plans',
                sort: true,
                formatter: planFormatter
              },
            {
              dataField: 'Status',
              text: 'Status',
              sort: true,
              formatter: statusFormatter
            },
            {
              dataField: "action",
              isDummyField: true,
              text: "",
              formatter: actionFormatter
            }];
      
            const defaultSorted = [{
              dataField: 'No',
              order: 'desc'
            }];
      
            function planFormatter(cellContent,row){
              return(
                <span> <strong>{row.recruitmentLines.length}</strong></span>
              )
            }
            function raisedByFormatter(cellContent,row){
                return(
                  <span> {row.RequisitionerNo}<br/>{row.RequisitionerName}</span>
                )
              }
            function positionFormatter(cellContent, row){
              return(
                <span> {row.PositionName}<br/>{row.PositionCode}</span>
              )
            }
            function noFormatter(cellContent, row){
              return(
                <strong>{cellContent}</strong>
              )
            }
      
            function actionFormatter(cellContent, row){
              return(
                <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ history.push(`/recruitment-requisition-details/${row.SystemId}`)}}
                >
                  Details
                </Button>
              )
            }
            function statusFormatter(cellContent, row) {
              if (row.Status == "Open") {
                return (
                  <div>
                      <Badge className="me-2 bg-danger">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Approved"){
                return (
                  <div>
                      <Badge className="me-2 bg-success">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Withdrawn(Cancelled)"){
                return (
                  <div>
                      <Badge className="me-2 bg-secondary">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else{
                return (
                  <div>
                      <Badge className="me-2 bg-warning">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }
            }
        
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Recruitment Requisitions | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Recruitment Requisitions" />
                        <Row>
                        <Col lg={12}>
                                {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                            </Col>
                        <Col xl={12}>
                            <Card>
                                <CardBody>


                                
                  
                               {(dCases.length > 0) && (<>

                                    <ToolkitProvider
                                        keyField="No"
                                        data={ dCases }
                                        columns={ columns }
                                        search
                                        >
                                        { toolkitProps => (
                                            <React.Fragment>
                                                <Row className='mb-5'>
                                                  <Col lg={8}>
                                                  <div  className="rounded bg-light d-grid gap-2">
                                           
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                 
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={4}> 
                                                  <div className="d-grid gap-2">
                                                    <Link
                                                      className="btn btn-primary"
                                                      to="/create-recruitment-requisition"
                                                    >
                                                      <i className="mdi mdi-plus me-1" />
                                                      Create Recruitment Requisition
                                                    </Link>
                                                  </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                <Col xl="12">
                                                    <div className="table">
                                                
                                                    <BootstrapTable 
                                                    keyField='No' 
                                                    data={ dCases } 
                                                    columns={ columns } 
                                                    striped
                                                    hover
                                                    condensed
                                                    bordered={ false }
                                                    noDataIndication="No Records" 
                                                    defaultSorted={ defaultSorted }
                                                    classes={ "table align-middle table-nowrap table-check" }
                                                        {...toolkitProps.baseProps}
                                                    />
                                                </div>
                                                </Col>
                                                </Row>
                                                </React.Fragment>
                                                
                                        )
                                        }
                                    </ToolkitProvider>
                  

                              
                                </>)}
                                {(dCases.length < 1) && (<>
                                    <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                
                                    
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>No Recruitment Requisitions found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>
                                    <div className="text-center mt-4">
                                        <Link
                                        to="/create-recruitment-requisition"
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Create Requisition <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                              
                                </Col>
                            </Row>
                                </>)}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                           

                    </Container>
                </div>
            </>
        );
    }

export default RecruitmentRequisitions;